var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAmex = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F72CD",
  d: "M7 13.914A3.914 3.914 0 0 1 10.914 10h37.838a3.914 3.914 0 0 1 3.915 3.914v13.048a3.914 3.914 0 0 1-3.915 3.914H10.914A3.914 3.914 0 0 1 7 26.962z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m15.187 15.871-4.273 9.456h5.115l.634-1.508h1.45l.634 1.508h5.63v-1.151l.502 1.15h2.912l.502-1.174v1.175h11.709l1.424-1.469 1.333 1.469 6.014.012-4.286-4.714 4.286-4.754h-5.92l-1.387 1.442-1.291-1.442H27.437l-1.094 2.44-1.12-2.44H20.12v1.112l-.567-1.112zm.99 1.343h2.493l2.834 6.412v-6.412h2.731l2.19 4.597 2.017-4.597h2.717V24h-1.653l-.014-5.317L27.082 24h-1.48l-2.424-5.317V24h-3.402l-.645-1.521h-3.484l-.644 1.52H13.18zm23.22 0h-6.725v6.78h6.62l2.134-2.246 2.056 2.247h2.15l-3.125-3.37 3.125-3.41h-2.056l-2.123 2.22zM17.39 18.362l-1.149 2.71h2.295zm16.943 1.496v-1.24h4.195l1.83 1.98-1.911 1.992h-4.114v-1.352H38v-1.38z",
  clipRule: "evenodd"
})));
export { SvgAmex as ReactComponent };
export default __webpack_public_path__ + "Amex.eabc3242.svg";